import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {
  PurchaseOrder,
  PurchaseOrderCreateRequest,
  PurchaseOrderMoveRequest,
  PurchaseOrderStatus,
  PurchaseOrderUpdateRequest
} from "./model/purchase-order";

@Injectable()
export class PurchaseOrderService {
  constructor(private http: HttpClient) {
  }

  list(statuses: PurchaseOrderStatus[], responsible: string[] | undefined, groupBySku: boolean, filter?: string, manufacturer?: string): Observable<PurchaseOrder[]> {
    let params = {
      status: statuses,
      responsible: responsible || [],
      groupBySku: groupBySku,
    } as any;
    if (manufacturer) {
      params["manufacturer"] = manufacturer;
    }
    if (filter) {
      params["filter"] = filter;
    }
    return this.http.get<PurchaseOrder[]>(environment.apiUrl + "/purchase-order", {params});
  }

  get(id: string): Observable<PurchaseOrder> {
    return this.http.get<PurchaseOrder>(environment.apiUrl + "/purchase-order/" + id)
  }

  create(request: PurchaseOrderCreateRequest): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(environment.apiUrl + "/purchase-order", request)
  }

  delete(id: string): Observable<any> {
    return this.http.delete(environment.apiUrl + "/purchase-order/" + id)
  }

  update(id: string, request: PurchaseOrderUpdateRequest): Observable<PurchaseOrder> {
    return this.http.put<PurchaseOrder>(environment.apiUrl + "/purchase-order/" + id, request)
  }

  move(request: PurchaseOrderMoveRequest): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(environment.apiUrl + "/purchase-order/move", request)
  }
}
